import React from 'react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import BarChartOutlined from '@material-ui/icons/BarChartOutlined';
import WavesOutlined from '@material-ui/icons/WavesOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import FolderOutlined from '@material-ui/icons/FolderOutlined';
import ViewComfyOutlinedIcon from '@mui/icons-material/ViewComfyOutlined';
import KeyResultPieBlueIcon from '../../vectors/key-result-pie-blue.svg';
import Menu from '../../styled-base/menu';
import MUIIcon from '../../styled-base/mui-icon';
import MeetingTabButton from './meetingTabButton';
import AgendaTemplatesModal from './modals/agendaTemplatesModal';
import MeetingServices from '../../services/meeting.services';

class MeetingAddDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTemplatesModal: false,
      hasTemplates: false,
    };
    this.menuItemRefs = {};
    this.MeetingServices = new MeetingServices();

    // Icon mapping for menu items
    this.iconMap = {
      objective: BarChartOutlined,
      key_result: KeyResultPieBlueIcon,
      workstream: WavesOutlined,
      ai: TaskAltOutlinedIcon,
      attachment: FolderOutlined,
      last_meeting_actions: TaskAltOutlinedIcon,
    };
  }

  componentDidMount() {
    const { meetingId } = this.props;
    this.MeetingServices.getAvailableTemplates(meetingId, 1, 1, '')
      .then((response) => {
        const result = response.data.data || {};
        const templates = result.templates || [];
        const pagination = result.pagination || {};
        const total = pagination.total || pagination.totalItems || templates.length;
        this.setState({ hasTemplates: total > 0 });
      })
      .catch(() => {
        this.setState({ hasTemplates: false });
      });
  }

  handleMenuItemClick = (itemId) => {
    // Find the hidden button container and click the button inside
    const container = document.getElementById(`meeting-dropdown-item-${itemId}`);
    if (container) {
      const button = container.querySelector('.meeting-btn-wrap');
      if (button) {
        button.click();
      }
    }

    // Satisfy linter
    return this;
  };

  handleOpenTemplatesModal = () => {
    this.setState({ showTemplatesModal: true });
  };

  handleCloseTemplatesModal = () => {
    this.setState({ showTemplatesModal: false });
  };

  handleTemplateAdded = () => {
    const { refreshLegacyData } = this.props;
    // Refresh legacy data after template is added - call without data to trigger full refresh
    if (refreshLegacyData) {
      refreshLegacyData();
    }
  };

  render() {
    const {
      t,
      goalModule,
      executeModule,
      isShowLastAiIcon,
      labelPlural,
      label,
      getAiFromLastMeetingUrl,
      actions,
      currentUser,
      meetingId,
      boxApiKey,
      dropBoxApiKey,
      addObjectiveItem,
      addKeyResultItem,
      addWorkStreamItem,
      addActionItem,
      addAttachment,
      addLastMeetingActions,
      closePopup,
      refreshLegacyData,
      accessToken,
      appInID,
      isFUSEnabled,
      deleteTopicTakeNonTake,
      msAppId,
      meetingRedirectUrl,
    } = this.props;

    const menuItems = [];
    const hiddenButtons = [];

    // Add Objectives if goalModule is enabled
    if (goalModule) {
      menuItems.push({
        id: 'objective',
        title: t('Objectives'),
      });
      hiddenButtons.push(
        <div key="objective" id="meeting-dropdown-item-objective" style={{ display: 'none' }}>
          <MeetingTabButton
            actions={actions}
            currentUser={currentUser}
            meetingId={meetingId}
            id="objective"
            title={t('Objectives')}
            url="goal/searchOKRresults"
            name={t('Add Objective')}
            placeholder={t('Search for an OKR by name, owner, or team')}
            boxApiKey={boxApiKey}
            dropBoxApiKey={dropBoxApiKey}
            addItem={addObjectiveItem}
            closePopup={closePopup}
            refreshLegacyData={refreshLegacyData}
            accessToken={accessToken}
            appInID={appInID}
            isFUSEnabled={isFUSEnabled}
            t={t}
          />
        </div>,
      );

      menuItems.push({
        id: 'key_result',
        title: t('Key Results'),
      });
      hiddenButtons.push(
        <div key="key_result" id="meeting-dropdown-item-key_result" style={{ display: 'none' }}>
          <MeetingTabButton
            actions={actions}
            currentUser={currentUser}
            meetingId={meetingId}
            id="key_result"
            title={t('Key Results')}
            url="goal/searchKRresults"
            name={t('Add Key Result')}
            placeholder={t('Search for a Key Result by name, owner, team, or tag')}
            boxApiKey={boxApiKey}
            dropBoxApiKey={dropBoxApiKey}
            addItem={addKeyResultItem}
            closePopup={closePopup}
            refreshLegacyData={refreshLegacyData}
            accessToken={accessToken}
            appInID={appInID}
            isFUSEnabled={isFUSEnabled}
            t={t}
          />
        </div>,
      );
    }

    // Add Execute module items
    if (executeModule) {
      menuItems.push({
        id: 'workstream',
        title: t('Workstreams'),
      });
      hiddenButtons.push(
        <div key="workstream" id="meeting-dropdown-item-workstream" style={{ display: 'none' }}>
          <MeetingTabButton
            actions={actions}
            currentUser={currentUser}
            meetingId={meetingId}
            id="workstream"
            title={t('Workstreams')}
            url="search/workstream"
            name={t('Add Workstreams')}
            placeholder={t('Search for a workstream by name, owner, or team')}
            boxApiKey={boxApiKey}
            dropBoxApiKey={dropBoxApiKey}
            addItem={addWorkStreamItem}
            closePopup={closePopup}
            refreshLegacyData={refreshLegacyData}
            accessToken={accessToken}
            appInID={appInID}
            isFUSEnabled={isFUSEnabled}
            t={t}
          />
        </div>,
      );

      menuItems.push({
        id: 'ai',
        title: labelPlural,
      });
      hiddenButtons.push(
        <div key="ai" id="meeting-dropdown-item-ai" style={{ display: 'none' }}>
          <MeetingTabButton
            actions={actions}
            currentUser={currentUser}
            meetingId={meetingId}
            id="ai"
            title={labelPlural}
            url="search/activity"
            name={t('Add {{label}}', { label })}
            placeholder={t('Search for an {{label}} by name, owner, or workstream', { label: label.toLowerCase() })}
            boxApiKey={boxApiKey}
            dropBoxApiKey={dropBoxApiKey}
            addItem={addActionItem}
            closePopup={closePopup}
            refreshLegacyData={refreshLegacyData}
            accessToken={accessToken}
            appInID={appInID}
            isFUSEnabled={isFUSEnabled}
            t={t}
          />
        </div>,
      );
    }

    // Add Files unless the org hides file uploads (M1B-394)
    if (!window.wbConfig.isMeetingsFileUploadHidden) {
      menuItems.push({
        id: 'attachment',
        title: t('Files'),
      });
      // visibility:hidden (not display:none) so FileUploadComp stays mounted and can toggle visible
      hiddenButtons.push(
        <div key="attachment" id="meeting-dropdown-item-attachment" style={{ position: 'absolute', visibility: 'hidden', pointerEvents: 'none' }}>
          <style>{'#meeting-dropdown-item-attachment .meetingAttachMenuWrap { visibility: visible; pointer-events: auto; }'}</style>
          <MeetingTabButton
            actions={actions}
            currentUser={currentUser}
            meetingId={meetingId}
            id="attachment"
            title={t('Files')}
            boxApiKey={boxApiKey}
            dropBoxApiKey={dropBoxApiKey}
            addItem={addAttachment}
            closePopup={closePopup}
            refreshLegacyData={refreshLegacyData}
            accessToken={accessToken}
            appInID={appInID}
            isFUSEnabled={isFUSEnabled}
            deleteTopicTakeNonTake={deleteTopicTakeNonTake}
            msAppId={msAppId}
            meetingRedirectUrl={meetingRedirectUrl}
            t={t}
          />
        </div>,
      );
    }

    // Add Last Meeting Actions if available
    if (isShowLastAiIcon && executeModule) {
      menuItems.push({
        id: 'last_meeting_actions',
        title: t('Last Meeting {{labelPlural}}', { labelPlural }),
      });
      hiddenButtons.push(
        <div key="last_meeting_actions" id="meeting-dropdown-item-last_meeting_actions" style={{ display: 'none' }}>
          <MeetingTabButton
            actions={actions}
            currentUser={currentUser}
            meetingId={meetingId}
            id="last_meeting_actions"
            title={t('Last Meeting {{labelPlural}}', { labelPlural })}
            url={getAiFromLastMeetingUrl}
            name={t('{{labelPlural}} from last meeting', { labelPlural })}
            placeholder={t('Search by {{label}}', { label })}
            addItem={addLastMeetingActions}
            closePopup={closePopup}
            refreshLegacyData={refreshLegacyData}
            accessToken={accessToken}
            appInID={appInID}
            isFUSEnabled={isFUSEnabled}
            t={t}
          />
        </div>,
      );
    }

    const AddButton = (
      <div
        className="meeting-add-dropdown-button"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          backgroundColor: 'transparent',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          height: '32px',
          gap: '4px',
          padding: 0,
        }}
      >
        <MUIIcon
          component={AddCircleOutlineIcon}
          style={{
            fontSize: 16,
            color: '#0072AB',
            display: 'flex',
          }}
        />
        <span
          style={{
            fontSize: '14px',
            color: '#0072AB',
            fontWeight: 700,
            userSelect: 'none',
            lineHeight: '16px',
          }}
        >
          {t('Add')}
        </span>
        <MUIIcon
          component={ExpandMoreIcon}
          style={{
            fontSize: 16,
            color: '#0072AB',
            display: 'flex',
          }}
        />
      </div>
    );

    const buttonStyle = {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      height: '32px',
      gap: '4px',
      padding: 0,
    };

    return (
      <div style={{
        display: 'flex', alignItems: 'center', gap: '20px', paddingLeft: '16px'
      }}
      >
        {/* Render hidden MeetingTabButton components */}
        {hiddenButtons}

        {/* Add Dropdown */}
        <Menu
          target={AddButton}
          showTarget
          targetClassName="meeting-add-dropdown-wrapper"
          portalClassName="meeting-add-dropdown-menu"
          fixedWidth={200}
          closeOnEsc
          yOffset={4}
        >
          {menuItems.map((item) => {
            const isFilesItem = item.id === 'attachment';
            const IconComponent = this.iconMap[item.id];

            return (
              <Menu.Item key={item.id} onClick={() => this.handleMenuItemClick(item.id)}>
                <div
                  className="meeting-add-dropdown-item"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    // padding: '0px 4px 6px 4px',
                    gap: '12px',
                    fontSize: '14px',
                    color: '#262626',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <div
                    style={{
                      width: '36px',
                      height: '36px',
                      minWidth: '36px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#E1F2FA',
                      borderRadius: '8px',
                      flexShrink: 0,
                    }}
                  >
                    {IconComponent && (
                      <MUIIcon
                        component={IconComponent}
                        style={{
                          fontSize: 20,
                          color: '#0072AB',
                        }}
                      />
                    )}
                  </div>
                  <span style={{ flex: 1, lineHeight: '20px' }}>{item.title}</span>
                  {isFilesItem && (
                    <MUIIcon
                      component={ChevronRightIcon}
                      style={{
                        fontSize: 20,
                        color: '#8c9ea2',
                        marginLeft: 'auto',
                      }}
                    />
                  )}
                </div>
              </Menu.Item>
            );
          })}
        </Menu>

        {/* Last Meeting Actions Button */}
        {isShowLastAiIcon && executeModule && (
          <button type="button" style={buttonStyle} onClick={() => this.handleMenuItemClick('last_meeting_actions')}>
            <MUIIcon
              component={ChecklistOutlinedIcon}
              style={{
                fontSize: 16,
                color: '#0072AB',
                display: 'flex',
              }}
            />
            <span
              style={{
                fontSize: '14px',
                color: '#0072AB',
                fontWeight: 700,
                userSelect: 'none',
                lineHeight: '16px',
              }}
            >
              {t('Last Meeting {{labelPlural}}', { labelPlural })}
            </span>
          </button>
        )}

        {/* Agenda Templates Button */}
        {this.state.hasTemplates && (
          <button
            type="button"
            style={buttonStyle}
            onClick={this.handleOpenTemplatesModal}
          >
            <MUIIcon
              component={ViewComfyOutlinedIcon}
              style={{
                fontSize: 16,
                color: '#0072AB',
                display: 'flex',
              }}
            />
            <span
              style={{
                fontSize: '14px',
                color: '#0072AB',
                fontWeight: 700,
                userSelect: 'none',
                lineHeight: '16px',
              }}
            >
              {t('Agenda Templates')}
            </span>
          </button>
        )}

        {/* Agenda Templates Modal */}
        {(() => {
          const { showTemplatesModal } = this.state;
          return showTemplatesModal && (
            <AgendaTemplatesModal
              t={t}
              meetingId={meetingId}
              onClose={this.handleCloseTemplatesModal}
              onTemplateAdded={this.handleTemplateAdded}
            />
          );
        })()}
      </div>
    );
  }
}

export default MeetingAddDropdown;
